import React from 'react';
import { useFragment } from 'react-relay/hooks';
import { graphql } from 'react-relay';
import classes from './OfferHistoryItem.module.scss';
import dayjs from 'dayjs';
import calendar from 'dayjs/plugin/calendar';

import { CASHBACK } from '../../pages/pages';
import ClockIcon from '../../assets/clock.svg';
import TickIcon from '../../assets/tick.svg';
import CrossIcon from '../../assets/cross.svg';
import { OfferHistoryItem_offer$key } from './__generated__/OfferHistoryItem_offer.graphql';
import Txt from '../../atoms/Txt/Txt';

export interface Props {
  offerRef: OfferHistoryItem_offer$key;
}

const fragmentSpec = graphql`
  fragment OfferHistoryItem_offer on OfferStatus {
    guid
    title
    advertiser {
      name
    }
    pendingAmount {
      formatted
    }
    approvedAmount {
      formatted
    }
    rejectedAmount {
      formatted
    }
    updatedAt
  }
`;

const OfferHistoryItem: React.FC<Props> = ({ offerRef }) => {
  const offer = useFragment(fragmentSpec, offerRef);

  dayjs.extend(calendar);

  function renderReward() {
    if (offer.pendingAmount) {
      return (
        <>
          <Txt>Pending</Txt> - {offer.pendingAmount.formatted}
          <ClockIcon className={classes.clock} />
        </>
      );
    }
    if (offer.rejectedAmount) {
      return (
        <>
          <Txt>Rejected</Txt> - <s>{offer.rejectedAmount.formatted}</s>
          <CrossIcon className={classes.cross} />
        </>
      );
    }
    if (offer.approvedAmount) {
      return (
        <>
          <Txt>Approved</Txt> - {offer.approvedAmount?.formatted}
          <TickIcon className={classes.tick} />
        </>
      );
    }
    return <Txt>Tracked</Txt>;
  }
  return (
    <tr className={classes.transactionContainer}>
      <th>
        <p className={classes.idText}>{`${dayjs(offer.updatedAt).calendar()}`}</p>
      </th>
      <td className={classes.dataWrapper}>
        <Txt skipTranslation component="h3" size="normal" className={classes.eventName}>
          <a href={`${CASHBACK.path}/${offer.guid}`} className={classes.link}>
            <Txt>Cashback</Txt> - {offer.advertiser?.name || offer.title}
          </a>
        </Txt>
        <p className={classes.pricingText}>{renderReward()}</p>
      </td>
    </tr>
  );
};

export default OfferHistoryItem;
